export default __webpack_public_path__ + "static/media/stdApplyingAvatar.335f69d4.png";